import { Profile } from '@/types';

export const profile: Profile = {
  name: 'Alaeddine ZORGUI',
  title: 'Frontend Engineer',
  location: 'Tunisia',
  openToRelocation: true,
  email: 'zorguialadinne@outlook.com',
  phone: '+216 26 413 266',
  social: {
    linkedin: 'https://www.linkedin.com/in/zorgui-alaeddine/',
    github: 'https://github.com/zorguiala',
  },
  summary: `Frontend Engineer with +5 years of experience building high-quality web applications in international, fast-paced environments. Strong focus on React, Next.js, TypeScript, performance, testing, and product quality. Experienced in remote collaboration and Agile workflows, with backend exposure (APIs, Rails, Node.js).`,
  languages: [
    { name: 'English', level: 'C1 - Fluent' },
    { name: 'French', level: 'B1/B2' },
    { name: 'Arabic', level: 'Native' },
  ],
  interests: ['Running', 'Dance'],
};

